import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byteConverts'
})
export class ByteConvertsPipe implements PipeTransform {

  transform(value: number, mode: string = 'MB') {
    let divider: number;
    switch (mode) {
      case 'KB':
        divider = 1024;
        break;
      case 'MB':
        divider = 1024 * 1024;
        break;
      case 'GB':
        divider = 1024 * 1024 * 1024;
        break;
      default:
        divider = 1024 * 1024;
        break;
    }
    return (Math.round(100 * value / (divider)) / 100);
  }

}
